{
  "action": {
    "administrationRecord": "Imprimir hoja de administración",
    "wristband": "Imprimir pulsera de identificación",
    "print": "Imprimir",
    "back": "Volver a la vista general del paciente",
    "recordExtract": "Imprimir extracto de la historia clínica"
  },
  "document": {
    "loading": "Cargando el documento para imprimir …",
    "failed": "No se ha podido cargar el documento para imprimir.",
    "notFound": "El paciente no consta en la historia clínica.",
    "retry": "Intentar de nuevo",
    "preview": "Vista previa. Esto es lo que saldrá en papel.",
    "confidentialityReview": "Identidad protegida. Revise antes de imprimir y antes de entregar el papel.",
    "source": "HISTORIA CLÍNICA DE CONTINGENCIA — MODO DE INTERRUPCIÓN",
    "printedAt": "Impreso desde Continuum {time}.",
    "printedAtUnknown": "No se ha podido indicar la hora de impresión.",
    "verify": "Los datos pueden haber cambiado después de la impresión. Compruébelos en la historia clínica."
  },
  "mar": {
    "heading": "Hoja de administración — medicamentos",
    "identification": "{name} — {identifier}",
    "noIdentifier": "sin identificador",
    "safetyHeading": "Información de seguridad",
    "medicationsHeading": "Prescripciones",
    "noMedications": "No hay prescripciones de medicamentos vigentes en la historia clínica.",
    "caption": "Prescripciones de medicamentos vigentes con casillas para firmar, una fila por prescripción.",
    "columnSigning": "Administrado — fecha, hora, firma",
    "signingHint": "Escriba la fecha, la hora y la firma de cada dosis administrada. Las casillas están vacías a propósito: el sistema no rellena horas.",
    "notInRecord": "En el modo de interrupción, los medicamentos administrados se documentan en papel y no se registran en la historia clínica en la fase 0.",
    "doseUnprintable": "NO SE PUEDE IMPRIMIR LA DOSIS",
    "doseWarning": "{count, plural, one {Una prescripción tiene una dosis que no se puede imprimir} other {# prescripciones tienen dosis que no se pueden imprimir}}. No firme sobre una casilla de dosis vacía: consulte la dosis en la historia clínica."
  },
  "wristband": {
    "heading": "Pulsera de identificación",
    "cutHint": "Recorte por la línea discontinua.",
    "born": "Nacimiento",
    "barcodeUnavailable": "No se puede imprimir un código de barras para este identificador. Lea el número de arriba.",
    "noIdentifier": "No hay identificador en la historia clínica. No se puede imprimir una pulsera sin identificador: un paciente no identificado debe tener un reservnummer.",
    "checkText": "Si el código de barras y las cifras no coinciden, prevalecen las cifras."
  },
  "extract": {
    "heading": "Extracto de la historia clínica",
    "scope": "El extracto muestra los datos actuales del paciente y todas las notas firmadas, de la más reciente a la más antigua. No incluye versiones anteriores de datos corregidos: permanecen en la historia clínica.",
    "admitted": "Ingreso",
    "medicationsHeading": "Medicamentos actuales",
    "medicationsCaption": "Prescripciones de medicamentos vigentes, una fila por prescripción.",
    "notesHeading": "Notas firmadas",
    "notesCount": "{count, plural, one {# nota firmada} other {# notas firmadas}}",
    "notesCaption": "Notas firmadas, de la más reciente a la más antigua.",
    "noNotes": "No hay notas firmadas en la historia clínica.",
    "forensic": "Marcada como relevante a efectos médico-legales"
  }
}
